<nb-card>
    <nb-card-body *ngIf="previewSize == 'small'">
        <div class="row">
            <div
                class="col-12 d-flex justify-content-center align-items-center"
            >
                <img
                    class="img-fluid img-responsive"
                    src="../../../assets/images/place1.png"
                />
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <h3>{{ articleData.title }}</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <span
                    *ngFor="let category of articleData.categories"
                    class="badge rounded-pill bg-primary mr-2"
                    style="color: #fff"
                    >{{ category }}</span
                >
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                {{ articleData.description }}
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12 text-center">
                <button
                    class="btn text-center btn-offset"
                    nbButton
                    size="small"
                    status="primary"
                    (click)="onReadMore(articleData.id)"
                >
                    READ MORE
                </button>
            </div>
        </div>
    </nb-card-body>
</nb-card>
